<template>
	<div class="mb-4">
		<v-card class="mb-3"
			color="grey lighten-1"
			justify-center>
			<br>

			<div class="text-xs-center mt-3 mb-3">
				<h2>{{formTitle}}</h2>
			</div>

			<v-container grid-list-md text-xs-center>
				<v-layout row wrap justify-center>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="off"
							data-vv-name="polishName"
							data-vv-as="Polska nazwa podmiotu"
							:error-messages="vErrors.collect('scope.polishName')"
							label="Polska nazwa podmiotu *"
							aria-label="label for subsidiary polish name"
							for="register-subsidiary-form-polish-name"
							id="register-subsidiary-form-polish-name"
							v-model="formData.polishName"
							v-validate="'required'"
							data-vv-scope="scope"
							class="text-xs-center">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="off"
							data-vv-name="englishName"
							data-vv-as="Angielska nazwa podmiotu"
							:error-messages="vErrors.collect('scope.englishName')"
							label="Angielska nazwa podmiotu *"
							aria-label="label for subsidiary english name"
							for="register-subsidiary-form-english-name"
							id="register-subsidiary-form-english-name"
							v-model="formData.englishName"
							v-validate="'required'"
							data-vv-scope="scope"
							class="text-xs-center">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="off"
							data-vv-name="name"
							data-vv-as="Imię"
							:error-messages="vErrors.collect('scope.name')"
							label="Imię *"
							aria-label="label for subsidiary name"
							for="register-subsidiary-form-name"
							id="register-subsidiary-form-name"
							v-model="formData.name"
							v-validate="'required'"
							data-vv-scope="scope"
							class="text-xs-center">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="off"
							data-vv-name="surname"
							data-vv-as="Nazwisko"
							:error-messages="vErrors.collect('scope.surname')"
							label="Nazwisko *"
							aria-label="label for subsidiary surname"
							for="register-subsidiary-form-surname"
							id="register-subsidiary-form-surname"
							v-model="formData.surname"
							v-validate="'required'"
							data-vv-scope="scope"
							class="text-xs-center">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="off"
							data-vv-name="phoneNumber"
							data-vv-as="Telefon kontaktowy"
							:error-messages="vErrors.collect('scope.phoneNumber')"
							label="Telefon kontaktowy *"
							aria-label="label for phone number"
							for="register-subsidiary-form-phone-number"
							id="register-subsidiary-form-phone-number"
							v-model="formData.phoneNumber"
							v-validate="{required: true, regex: /^[0-9 +-]*$/}"
							data-vv-validate-on="none"
							data-vv-scope="scope"
							class="text-xs-center">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="off"
							data-vv-name="email"
							data-vv-as="E-mail"
							:error-messages="vErrors.collect('scope.email')"
							label="E-mail *"
							aria-label="label for email"
							for="register-subsidiary-form-email"
							id="register-subsidiary-form-email"
							v-model="formData.email"
							v-validate="'required|email'"
							data-vv-validate-on="none"
							data-vv-scope="scope"
							class="text-xs-center">
						</v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

				</v-layout>
			</v-container>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="$emit('cancel')" color="blue" class="mr-2 mb-3">Anuluj</v-btn>
				<v-btn color="primary" @click="$emit('register',formData, 'scope')" class="mr-5 mb-3">Rejestruj</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
	export default {
		name: "RegisterSubsidiaryForm",

		inject: ["parentValidator"],

		created() {
			this.$validator = this.parentValidator;
		},

		data() {
			return {
				formTitle: "Dodaj subkonto",
				publicPath: process.env.BASE_URL,
			};
		},

		props: {
			formData: Object,
		},
	};
</script>

<style scoped>

</style>
